/* eslint-disable max-len,radix */
import { merge } from 'ramda';
import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_JOBS_REQUEST';
export const SUCCESS = 'LOAD_JOBS_SUCCESS';
export const FAIL = 'LOAD_JOBS_FAIL';

export const LOAD_JOBS_BY_DEPARTMENT_ID_REQUEST = 'LOAD_JOBS_BY_DEPARTMENT_ID_REQUEST';
export const LOAD_JOBS_BY_DEPARTMENT_ID_SUCCESS = 'LOAD_JOBS_BY_DEPARTMENT_ID_SUCCESS';
export const LOAD_JOBS_BY_DEPARTMENT_ID_FAIL = 'LOAD_JOBS_BY_DEPARTMENT_ID_FAIL';

export const LOAD_WORK_EFFORT_TYPES_REQUEST = 'LOAD_WORK_EFFORT_TYPES_REQUEST';
export const LOAD_WORK_EFFORT_TYPES_SUCCESS = 'LOAD_WORK_EFFORT_TYPES_SUCCESS';
export const LOAD_WORK_EFFORT_TYPES_FAIL = 'LOAD_WORK_EFFORT_TYPES_FAIL';

export const REQUEST_DEPARTMENT_BY_JOB = 'LOAD_DEPARTMENTS_BY_JOB_REQUEST';
export const SUCCESS_DEPARTMENT_BY_JOB = 'LOAD_DEPARTMENTS_BY_JOB_SUCCESS';
export const FAIL_DEPARTMENT_BY_JOB = 'LOAD_DEPARTMENTS_BY_JOB_FAIL';

export const REQUEST_JOB_INTO_DEPARTMENT = 'POST_JOB_INTO_DEPARTMENT_REQUEST';
export const SUCCESS_JOB_INTO_DEPARTMENT = 'POST_JOB_INTO_DEPARTMENT_SUCCESS';
export const FAIL_JOB_INTO_DEPARTMENT = 'POST_JOB_INTO_DEPARTMENT_FAIL';

export const ERASE_JOBS_IN_DEPARTMENT = 'ERASE_JOBS_IN_DEPARTMENT';

export const PUT_JOB_REQUEST = 'PUT_JOB_REQUEST';
export const PUT_JOB_SUCCESS = 'PUT_JOB_SUCCESS';
export const PUT_JOB_FAIL = 'PUT_JOB_FAIL';

export const PUT_JOBS_MULTIPLE_REQUEST = 'PUT_JOBS_MULTIPLE_REQUEST';
export const PUT_JOBS_MULTIPLE_SUCCESS = 'PUT_JOBS_MULTIPLE_SUCCESS';
export const PUT_JOBS_MULTIPLE_FAIL = 'PUT_JOBS_MULTIPLE_FAIL';

export const DELETE_JOBS_USERS_MULTIPLE_REQUEST = 'DELETE_JOBS_USERS_MULTIPLE_REQUEST';
export const DELETE_JOBS_USERS_MULTIPLE_SUCCESS = 'DELETE_JOBS_USERS_MULTIPLE_SUCCESS';
export const DELETE_JOBS_USERS_MULTIPLE_FAIL = 'DELETE_JOBS_USERS_MULTIPLE_FAIL';

export const DELETE_JOBS_DEPARTMENTS_MULTIPLE_REQUEST = 'DELETE_JOBS_DEPARTMENTS_MULTIPLE_REQUEST';
export const DELETE_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS = 'DELETE_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS';
export const DELETE_JOBS_DEPARTMENTS_MULTIPLE_FAIL = 'DELETE_JOBS_DEPARTMENTS_MULTIPLE_FAIL';

export const POST_JOBS_DEPARTMENTS_MULTIPLE_REQUEST = 'POST_JOBS_DEPARTMENTS_MULTIPLE_REQUEST';
export const POST_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS = 'POST_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS';
export const POST_JOBS_DEPARTMENTS_MULTIPLE_FAIL = 'POST_JOBS_DEPARTMENTS_MULTIPLE_FAIL';

export const POST_JOB_REQUEST = 'POST_JOB_REQUEST';
export const POST_JOB_SUCCESS = 'POST_JOB_SUCCESS';
export const POST_JOB_FAIL = 'POST_JOB_FAIL';

export const DELETE_JOB_FROM_DEPARTMENT_REQUEST = 'DELETE_JOB_FROM_DEPARTMENT_REQUEST';
export const DELETE_JOB_FROM_DEPARTMENT_SUCCESS = 'DELETE_JOB_FROM_DEPARTMENT_SUCCESS';
export const DELETE_JOB_FROM_DEPARTMENT_FAIL = 'DELETE_JOB_FROM_DEPARTMENT_FAIL';

export const DELETE_JOB_REQUEST = 'DELETE_JOB_REQUEST';
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS';
export const DELETE_JOB_FAIL = 'DELETE_JOB_FAIL';

export const OPTIONS_SUCCESS = 'LOAD_JOBS_OPTIONS_SUCCESS';

export const GET_JOBS_CONDITIONAL_DELETE_REQUEST = 'GET_JOBS_CONDITIONAL_DELETE_REQUEST';
export const GET_JOBS_CONDITIONAL_DELETE_SUCCESS = 'GET_JOBS_CONDITIONAL_DELETE_SUCCESS';
export const GET_JOBS_CONDITIONAL_DELETE_FAIL = 'GET_JOBS_CONDITIONAL_DELETE_FAIL';

export const LOAD_JOB_SWAPS_SUCCESS = 'LOAD_JOB_SWAPS_SUCCESS';
export const POST_JOB_SWAP_SUCCESS = 'POST_JOB_SWAP_SUCCESS';
export const DELETE_JOB_SWAP_SUCCESS = 'DELETE_JOB_SWAP_SUCCESS';

export const LOAD_JOB_REPLACES_REQUEST = 'LOAD_JOB_REPLACES_REQUEST';
export const LOAD_JOB_REPLACES_SUCCESS = 'LOAD_JOB_REPLACES_SUCCESS';
export const LOAD_JOB_REPLACES_FAIL = 'LOAD_JOB_REPLACES_FAIL';
export const POST_JOB_REPLACE_SUCCESS = 'POST_JOB_REPLACE_SUCCESS';
export const DELETE_JOB_REPLACE_SUCCESS = 'DELETE_JOB_REPLACE_SUCCESS';

export const LOAD_PLANNED_ABSENCES_REQUEST = 'LOAD_PLANNED_ABSENCES_REQUEST';
export const LOAD_PLANNED_ABSENCES_SUCCESS = 'LOAD_PLANNED_ABSENCES_SUCCESS';
export const LOAD_PLANNED_ABSENCES_FAIL = 'LOAD_PLANNED_ABSENCES_FAIL';
export const POST_PLANNED_ABSENCE_SUCCESS = 'POST_PLANNED_ABSENCE_SUCCESS';
export const DELETE_PLANNED_ABSENCE_SUCCESS = 'DELETE_PLANNED_ABSENCE_SUCCESS';

export const loadJobsSuccess = (jobs) => ({ type: SUCCESS, jobs });
export const loadJobsRequest = () => ({ type: REQUEST });
export const loadJobsFail = (error) => ({ type: FAIL, error });

export const loadJobsByDepartmentIdSuccess = (payload) => ({ type: LOAD_JOBS_BY_DEPARTMENT_ID_SUCCESS, payload });
export const loadJobsByDepartmentIdRequest = () => ({ type: LOAD_JOBS_BY_DEPARTMENT_ID_REQUEST });
export const loadJobsByDepartmentIdFail = (error) => ({ type: LOAD_JOBS_BY_DEPARTMENT_ID_FAIL, error });

const loadDepartmentsByJobSuccess = (departments, jobId) => ({ type: SUCCESS_DEPARTMENT_BY_JOB, departments, jobId });
const loadDepartmentsByJobRequest = (jobId) => ({ type: REQUEST_DEPARTMENT_BY_JOB, jobId });
const loadDepartmentsByJobFail = (error) => ({ type: FAIL_DEPARTMENT_BY_JOB, error });

const postJobIntoDepartmentSuccess = (data, DepartmentName) => ({ type: SUCCESS_JOB_INTO_DEPARTMENT, payload: merge(data, DepartmentName) });

const postJobIntoDepartmentRequest = (jobId) => ({ type: REQUEST_JOB_INTO_DEPARTMENT, jobId });
const postJobIntoDepartmentFail = (error) => ({ type: FAIL_JOB_INTO_DEPARTMENT, error });

const putJobSuccess = (job, options) => ({ type: PUT_JOB_SUCCESS, job, options });
const putJobRequest = (job) => ({ type: PUT_JOB_REQUEST, job });
const putJobFail = (error) => ({ type: PUT_JOB_FAIL, error });

const putJobsMultipleSuccess = () => ({ type: PUT_JOBS_MULTIPLE_SUCCESS });
const putJobsMultipleRequest = () => ({ type: PUT_JOBS_MULTIPLE_REQUEST });
const putJobsMultipleFail = (error) => ({ type: PUT_JOBS_MULTIPLE_FAIL, error });

const deleteJobsUsersMultipleSuccess = () => ({ type: DELETE_JOBS_USERS_MULTIPLE_SUCCESS });
const deleteJobsUsersMultipleRequest = () => ({ type: DELETE_JOBS_USERS_MULTIPLE_REQUEST });
const deleteJobsUsersMultipleFail = (error) => ({ type: DELETE_JOBS_USERS_MULTIPLE_FAIL, error });

const deleteJobsDepartmentsMultipleSuccess = () => ({ type: DELETE_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS });
const deleteJobsDepartmentsMultipleRequest = () => ({ type: DELETE_JOBS_DEPARTMENTS_MULTIPLE_REQUEST });
const deleteJobsDepartmentsMultipleFail = (error) => ({ type: DELETE_JOBS_DEPARTMENTS_MULTIPLE_FAIL, error });

const postJobsDepartmentsMultipleSuccess = () => ({ type: POST_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS });
const postJobsDepartmentsMultipleRequest = () => ({ type: POST_JOBS_DEPARTMENTS_MULTIPLE_REQUEST });
const postJobsDepartmentsMultipleFail = (error) => ({ type: POST_JOBS_DEPARTMENTS_MULTIPLE_FAIL, error });

const deleteJobFromDepartmentRequest = (jobId, departmentId) => ({ type: DELETE_JOB_FROM_DEPARTMENT_REQUEST, jobId, departmentId });
const deleteJobFromDepartmentFail = (error) => ({ type: DELETE_JOB_FROM_DEPARTMENT_FAIL, error });
const deleteJobFromDepartmentSuccess = (jobId, departmentId) => ({ type: DELETE_JOB_FROM_DEPARTMENT_SUCCESS, jobId, departmentId });

const deleteJobRequest = (jobId) => ({ type: DELETE_JOB_REQUEST, jobId });
const deleteJobFail = (error) => ({ type: DELETE_JOB_FAIL, error });
const deleteJobSuccess = (jobId, options) => ({ type: DELETE_JOB_SUCCESS, jobId, options });

const postJobSuccess = (data, options) => ({ type: POST_JOB_SUCCESS, data, options });
const postJobRequest = (data) => ({ type: POST_JOB_REQUEST, data });
const postJobFail = (error) => ({ type: POST_JOB_FAIL, error });

const getJobsConditionalDeleteRequest = () => ({ type: GET_JOBS_CONDITIONAL_DELETE_REQUEST });
const getJobsConditionalDeleteSuccess = (data) => ({ type: GET_JOBS_CONDITIONAL_DELETE_SUCCESS, data });
const getJobsConditionalDeleteFail = () => ({ type: GET_JOBS_CONDITIONAL_DELETE_FAIL });

export const loadJobsOptionsSuccess = (jobs) => ({ type: OPTIONS_SUCCESS, jobs });

export const loadJobSwapsSuccess = (payload) => ({ type: LOAD_JOB_SWAPS_SUCCESS, payload });
export const postJobSwapSuccess = (payload) => ({ type: POST_JOB_SWAP_SUCCESS, payload });
export const deleteJobSwapSuccess = (payload) => ({ type: DELETE_JOB_SWAP_SUCCESS, payload });

export const loadJobReplacesRequest = () => ({ type: LOAD_JOB_REPLACES_REQUEST });
export const loadJobReplacesSuccess = (payload) => ({ type: LOAD_JOB_REPLACES_SUCCESS, payload });
export const loadJobReplacesFail = () => ({ type: LOAD_JOB_REPLACES_FAIL });
export const postJobReplaceSuccess = (payload) => ({ type: POST_JOB_REPLACE_SUCCESS, payload });
export const deleteJobReplaceSuccess = (payload) => ({ type: DELETE_JOB_REPLACE_SUCCESS, payload });

export const loadPlannedAbsencesRequest = () => ({ type: LOAD_PLANNED_ABSENCES_REQUEST });
export const loadPlannedAbsencesSuccess = (payload) => ({ type: LOAD_PLANNED_ABSENCES_SUCCESS, payload });
export const loadPlannedAbsencesFail = () => ({ type: LOAD_PLANNED_ABSENCES_FAIL });
export const postPlannedAbsenceSuccess = (payload) => ({ type: POST_PLANNED_ABSENCE_SUCCESS, payload });
export const deletePlannedAbsenceSuccess = (payload) => ({ type: DELETE_PLANNED_ABSENCE_SUCCESS, payload });

export const eraseJobsInDepartment = () => ({ type: ERASE_JOBS_IN_DEPARTMENT });

export const reformatJobsForOptionsMenu = (data) =>
  // reformat data for options menu {value:1, label:'menuTxt'}
  // eslint-disable-next-line implicit-arrow-linebreak
  data.map((job) => ({
    value: `${job.JobId || job.Id}`,
    label: job.JobName || job.Name
  }));

export const loadJobs = () => (dispatch) => {
  dispatch(loadJobsRequest());
  return communicate({ url: 'Jobs', method: 'get' }).then((response) => {
    dispatch(loadJobsSuccess(response.data.Data));
    dispatch(loadJobsOptionsSuccess(reformatJobsForOptionsMenu(response.data.Data)));
  }).catch((err) => {
    dispatch(loadJobsFail(err));
    toastrError(err);
  });
};

export const loadJobsOptions = () => (dispatch) => {
  dispatch(loadJobsRequest());
  return communicate({ url: 'Jobs/Basic', method: 'get' }).then((response) => {
    dispatch(loadJobsOptionsSuccess(reformatJobsForOptionsMenu(response.data.Data)));
  }).catch((err) => {
    dispatch(loadJobsFail(err));
    toastrError(err);
  });
};

export const loadJobsByDepartmentId = (departmentId) => (dispatch) => {
  dispatch(loadJobsByDepartmentIdRequest());
  return communicate({ url: 'Jobs', method: 'get', getParams: `?departmentIds=${departmentId}` }).then((response) => {
    dispatch(loadJobsByDepartmentIdSuccess({ departmentId, list: response.data.Data }));
  }).catch((err) => {
    dispatch(loadJobsByDepartmentIdFail(err));
    toastrError(err);
  });
};

export const loadDepartmentsByJobId = (jobId) => (dispatch) => {
  dispatch(loadDepartmentsByJobRequest(jobId));
  return communicate({ url: 'Departments', method: 'get', getParams: `?jobIds=${jobId}` })
    .then((response) => {
      dispatch(loadDepartmentsByJobSuccess(response.data.Data, jobId));
    }).catch((e) => {
      dispatch(loadDepartmentsByJobFail(e));
      toastrError(e);
    });
};

export const postJobIntoDepartment = (params) => (dispatch) => {
  dispatch(postJobIntoDepartmentRequest(params));
  return communicate({ url: 'JobDepartments', method: 'post', data: params })
    .then((response) => {
      const DepartmentId = parseInt(params.DepartmentId, 10);
      dispatch(postJobIntoDepartmentSuccess(response.data.Data, { ...params, DepartmentId }));
      toastrSuccess(response);
    }).catch((e) => {
      dispatch(postJobIntoDepartmentFail(e));
      toastrError(e);
    });
};

export const deleteJobFromDepartment = (jobId, departmentId) => (dispatch) => {
  dispatch(deleteJobFromDepartmentRequest(jobId, departmentId));
  return communicate({ url: 'JobDepartments', method: 'delete', getParams: `?jobId=${jobId}&departmentId=${departmentId}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobFromDepartmentSuccess(jobId, departmentId));
    }).catch((e) => {
      dispatch(deleteJobFromDepartmentFail(e));
      toastrError(e);
    });
};

export const deleteJob = (params) => (dispatch) => {
  dispatch(deleteJobRequest(params.jobId));
  return communicate({ url: 'Jobs', method: 'delete', getParams: `?id=${params.jobId}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobSuccess(params.jobId, { value: params.jobId.toString(), label: params.jobName }));
    }).catch((e) => {
      dispatch(deleteJobFail(e));
      toastrError(e);
    });
};

export const putJob = (params) => (dispatch) => {
  dispatch(putJobRequest(params));
  return communicate({
    url: 'Jobs',
    method: 'put',
    data: params
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(putJobSuccess(params, { value: params.JobId.toString(), label: params.JobName }));
    }).catch((err) => {
      dispatch(putJobFail(err));
      toastrError(err);
    });
};

export const loadUserJobs = (params) => communicate({
  url: 'JobUser',
  getParams: Utils.objects.getQueryStringFromObject(params)
});

export const putJobsMultiple = (params) => (dispatch) => {
  dispatch(putJobsMultipleRequest());
  return communicate({
    url: 'JobUser/multiple',
    method: 'post',
    data: params
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(putJobsMultipleSuccess());
      return true;
    })
    .catch((err) => {
      dispatch(putJobsMultipleFail());
      toastrError(err);
      return false;
    });
};

export const deleteJobsUsersMultiple = (params) => (dispatch) => {
  dispatch(deleteJobsUsersMultipleRequest());
  return communicate({
    url: 'JobUser/multiple',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobsUsersMultipleSuccess());
      return true;
    })
    .catch((err) => {
      dispatch(deleteJobsUsersMultipleFail());
      toastrError(err);
      return false;
    });
};

export const deleteJobsDepartmentsMultiple = (params) => (dispatch) => {
  dispatch(deleteJobsDepartmentsMultipleRequest());
  return communicate({
    url: 'JobDepartments/multiple',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobsDepartmentsMultipleSuccess());
      return true;
    })
    .catch((err) => {
      dispatch(deleteJobsDepartmentsMultipleFail());
      toastrError(err);
      return false;
    });
};

export const postJobsDepartmentsMultiple = (params) => (dispatch) => {
  dispatch(postJobsDepartmentsMultipleRequest());
  return communicate({
    url: 'JobDepartments/multiple',
    method: 'post',
    data: params
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(postJobsDepartmentsMultipleSuccess());
      return true;
    })
    .catch((err) => {
      dispatch(postJobsDepartmentsMultipleFail());
      toastrError(err);
      return false;
    });
};

export const postJob = (params, departmentId) => (dispatch) => {
  dispatch(postJobRequest(params));
  return communicate({ url: `Jobs?departmentId=${parseInt(departmentId)}`, method: 'post', data: params })
    .then((response) => {
      dispatch(postJobSuccess([response.data.Data], reformatJobsForOptionsMenu([response.data.Data])));
      toastrSuccess(response);
      return response.data.Data;
    }).catch((e) => {
      dispatch(postJobFail(e));
      toastrError(e);
    });
};

export const getJobsConditionalDelete = (id) => (dispatch) => {
  dispatch(getJobsConditionalDeleteRequest());
  return communicate({ url: 'Jobs/ConditionalDelete', method: 'delete', getParams: `?id=${id}` }).then((response) => {
    dispatch(getJobsConditionalDeleteSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(getJobsConditionalDeleteFail(err));
    toastrError(err);
  });
};

export const loadJobSwaps = (params) => (dispatch) => (
  communicate({ url: 'JobSwaps', method: 'get', getParams: Utils.objects.objectToQueryString(params) })
    .then((response) => {
      const swaps = response.data.Data;
      dispatch(loadJobSwapsSuccess(swaps));
      return Promise.resolve(swaps);
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    }));

export const postJobSwap = (payload) => (dispatch) => (
  communicate({ url: 'JobSwaps', method: 'post', data: payload })
    .then((response) => {
      toastrSuccess(response);
      const swap = response.data.Data;
      dispatch(postJobSwapSuccess(swap));
      return Promise.resolve(swap);
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    }));

export const deleteJobSwap = (id) => (dispatch) => (
  communicate({ url: 'JobSwaps', method: 'delete', getParams: Utils.objects.objectToQueryString({ id }) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobSwapSuccess(id));
      return Promise.resolve();
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    }));

export const loadJobReplaces = (params) => (dispatch) => {
  dispatch(loadJobReplacesRequest());
  return communicate({ url: 'JobReplace', method: 'get', getParams: Utils.objects.objectToQueryString(params) })
    .then((response) => {
      const replaces = response.data.Data;
      dispatch(loadJobReplacesSuccess(replaces));
      return Promise.resolve(replaces);
    })
    .catch((e) => {
      dispatch(loadJobReplacesFail());
      toastrError(e);
      return Promise.reject();
    });
};

export const loadPlannedAbsences = () => (dispatch) => {
  dispatch(loadPlannedAbsencesRequest());
  return communicate({
    url: 'v2/PlannedAbsence/Search'
  })
    .then((response) => {
      const ids = response.data.Data;
      dispatch(loadPlannedAbsencesSuccess(ids));
      return Promise.resolve(ids);
    })
    .catch((e) => {
      dispatch(loadPlannedAbsencesFail());
      toastrError(e);
      return Promise.reject();
    });
};

export const postPlannedAbsence = (absenceId) => (dispatch) => {
  return communicate({
    url: 'v2/PlannedAbsence/Create',
    method: 'post',
    data: { JobId: absenceId }
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(postPlannedAbsenceSuccess(absenceId));
      return Promise.resolve(absenceId);
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    });
};

export const deletePlannedAbsence = (absenceId) => (dispatch) => {
  return communicate({
    url: 'v2/PlannedAbsence/Delete',
    method: 'delete',
    getParams: Utils.objects.objectToQueryString({ JobId: absenceId })
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deletePlannedAbsenceSuccess(absenceId));
      return Promise.resolve(absenceId);
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    });
};

export const postJobReplace = (payload) => (dispatch) => (
  communicate({ url: 'JobReplace', method: 'post', data: payload })
    .then((response) => {
      toastrSuccess(response);
      const replace = response.data.Data;
      dispatch(postJobReplaceSuccess(replace));
      return Promise.resolve(replace);
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    }));

export const deleteJobReplace = (id) => (dispatch) => (
  communicate({ url: 'JobReplace', method: 'delete', getParams: Utils.objects.objectToQueryString({ id }) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteJobReplaceSuccess(id));
      return Promise.resolve();
    })
    .catch((e) => {
      toastrError(e);
      return Promise.reject();
    }));
